// This build serves both local development (localhost:4220) and the testlab host, and the identity
// server turns clientUrl into the redirect / silent-refresh URIs — so it has to follow wherever the
// app is actually served from. A hardcoded host silently breaks SSO on the other one.
const clientUrl = window.location.origin;

export const environment = {
  production: false,
  gatewayApiUrl: 'https://esw-testlab-gateway-api.azurewebsites.net',
  staticContentStorage: 'https://static.kros.sk/shared',
  appInsightsInstrumentationKey: '916b13b1-3ef7-4849-a0a7-21649447d433',
  appInsightsSamplingPercentage: 25,
  invoicingAppUrl: 'https://fakturacia.kros.wtf',
  krosOfficeUrl: 'https://app.kros.wtf',
  invoicingTrialUrl: 'https://kros.sk/fakturacia',
  eShopUrl: 'https://eshoptest.kros.sk',
  identityServer: {
    url: 'https://login.kros.wtf',
    clientUrl,
  },
};
